<template>
  <v-list>
    <template v-for="(item, index) in sortedCurrentNavItems">
      <component :is="item.component" :key="`nav-${index}`"></component>
    </template>
  </v-list>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { NAMESPACE } from '../store'

export default {
  computed: {
    ...mapGetters(NAMESPACE, ['sortedCurrentNavItems']),
    ...mapState(NAMESPACE, ['currentNav'])
  }
}
</script>

<style scoped lang="scss">
.v-list {
  padding: 0;
  .v-subheader {
    text-transform: uppercase;
  }
}
</style>
